import React, { useState } from 'react';
import { Link } from '@material-ui/core';
import PropTypes from 'prop-types';

import { Link as RouterLink } from 'react-router-dom';
import { appRoutes } from 'routes';
import BurgerIcon from '@material-ui/icons/DragHandleRounded';
import Icon from 'sharedComponents/Icon';
import SideBar from './components/SideBar';
import useStyles from './useStyles';

const MobileNonAuthHeader = props => {
  const { isBuyerLocation } = props;
  const classes = useStyles();
  const [isSideBarOpen, setSidebarOpen] = useState(false);

  const handleToggleSideBar = () => {
    setSidebarOpen(prevState => setSidebarOpen(!prevState));
  };

  return (
    <div className={classes.container}>
      <Link to={appRoutes.rootPath} component={RouterLink}>
        <Icon name="logo" width="100" />
      </Link>
      <a className={classes.call} href="tel:+19802601510">
        (980) 260-1510
      </a>
      <BurgerIcon className={classes.burger} onClick={handleToggleSideBar} />
      <SideBar onClose={handleToggleSideBar} isOpen={isSideBarOpen} isBuyerLocation={isBuyerLocation} />
    </div>
  );
};

MobileNonAuthHeader.propTypes = {
  isBuyerLocation: PropTypes.bool.isRequired,
};

export default MobileNonAuthHeader;



// WEBPACK FOOTER //
// ./src/sharedComponents/MobileNonAuthHeader/MobileNonAuthHeader.js